var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { StoreContext } from '../uistore/Rootstore';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { AppColor, FontSize } from '../const/AppDefaults';
import { ScaleLoader } from 'react-spinners';
import { DraftType } from '@@/Draft';
import { AnnotationType, NoteType } from '@@/Annotation';
const FloatingEditor = React.lazy(async () => await import("../UIComponents/FloatingEditor"));
import { MdLink } from '@react-icons/all-files/md/MdLink';
import { FiList } from '@react-icons/all-files/fi/FiList';
import { testIsMobile } from '@@/Util';
let FloatingObjectViewer = class FloatingObjectViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.floatingStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.floatingStore.dragging) {
                // lets move this dialog 
                rstore.floatingStore.setTop(e.clientY - this.adjusty);
                rstore.floatingStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    addLink() {
        var _a, _b;
        const rstore = this.context;
        let objectid = rstore.floatingStore.activedocumentid;
        if (rstore.floatingStore.selectionmode) {
            const ob = rstore.objectChooserStore.getProjectObject(rstore.floatingPdfViewerStore.activeobjectid);
            if (ob) {
                (_b = (_a = rstore.objectChooserStore).selectioncb) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    obj: ob,
                    type: 'document',
                    id: "objs-" + ob.id
                });
            }
            rstore.floatingStore.setShow(false);
            rstore.floatingStore.reset();
            if (rstore.letrAndTagStore.canViewDocument()) {
                rstore.objectChooserStore.setActiveView("project");
            }
            else if (rstore.letrAndTagStore.canViewDatasheet()) {
                rstore.objectChooserStore.setActiveView("datasheet");
            }
            rstore.objectChooserStore.setShow(false);
            rstore.objectChooserStore.reset();
            return;
        }
        let fileid = rstore.floatingPdfViewerStore.activedraftid;
        if (rstore.floatingDraftViewStore.showdraftingview) {
            objectid = rstore.floatingDraftViewStore.objectid;
            fileid = rstore.floatingDraftViewStore.draftid;
        }
        const ismaindraft = rstore.draftDetailStore.showdraftingview || rstore.documentDetailStore.isexcel;
        const name = rstore.floatingStore.title;
        if (!rstore.floatingDraftViewStore.showdraftingview) {
            let note;
            if (!rstore.documentDetailStore.isexcel && rstore.floatingPdfViewerStore.pageshaveactivehighlight.size > 0) {
                note = rstore.floatingPdfViewerStore.saveAnnotation(true, false);
            }
            if (note === undefined) {
                let marking = "text:" + 0 + ":" + -1 + ":" + 0 + ":" +
                    -1;
                if (rstore.floatingStore.isexcel) {
                    marking = rstore.floatingDraftViewStore.getActiveMarking();
                }
                const databox = {
                    detail: [{ key: 'systemtext', value: '' }],
                    notetype: AnnotationType.Rectangle,
                    boxes: [[0, 0, 0, 0]],
                    match: marking,
                    color: 'blue',
                    storekthickness: -1
                };
                note = {
                    id: "",
                    data: databox,
                    type: NoteType.NoteLink,
                    viewer: [],
                    parentid: "",
                    authorname: "",
                    authorid: "",
                    updatetime: 0,
                    replycount: 0,
                    aclstr: "---",
                    notereference: fileid
                };
            }
            let initiatorid = rstore.miniviewStore.activedraftid;
            if (rstore.letrAndTagStore.activeview === 'datasheet') {
                initiatorid = "datasheet-" + rstore.mainSchemaStore.activedatasheet + "-" +
                    rstore.mainSchemaStore.activeschema + "-" + rstore.mainSchemaStore.activerowid;
            }
            const lnote = {
                objectid: objectid,
                fileid: fileid,
                name: name,
                note: note,
                initiatorid: initiatorid
            };
            // check if it's datasheet mode!!
            if (rstore.letrAndTagStore.activeview === 'datasheet') {
                rstore.mainSchemaStore.addLink(lnote);
            }
            else {
                if (ismaindraft) {
                    rstore.draftDetailStore.setLink(lnote);
                }
                else {
                    rstore.miniviewStore.setLink(lnote);
                }
            }
        }
        else if (rstore.floatingDraftViewStore.showdraftingview) {
            // lets add new links here too!!
            let note;
            if (rstore.floatingDraftViewStore.startindex != '') {
                note = rstore.floatingDraftViewStore.saveNote(false);
            }
            if (note === undefined) {
                const marking = "docdraft:" + 0 + ":";
                const databox = {
                    detail: [{ key: 'systemtext', value: '' }],
                    notetype: AnnotationType.Freehand,
                    boxes: [],
                    match: marking,
                    color: 'blue',
                    storekthickness: -1
                };
                note = {
                    id: "",
                    data: databox,
                    type: NoteType.Note,
                    viewer: [],
                    parentid: "",
                    authorname: "",
                    authorid: "",
                    updatetime: 0,
                    replycount: 0,
                    aclstr: "---",
                    notereference: fileid
                };
            }
            let initiatorid = rstore.miniviewStore.activedraftid;
            if (rstore.letrAndTagStore.activeview === 'datasheet') {
                initiatorid = "datasheet-" + rstore.mainSchemaStore.activedatasheet + "-" +
                    rstore.mainSchemaStore.activeschema + "-" + rstore.mainSchemaStore.activerowid;
            }
            const lnote = {
                objectid: objectid,
                fileid: fileid,
                name: name,
                note: note,
                drafttype: rstore.floatingDraftViewStore.drafttype,
                initiatorid: initiatorid
            };
            // check if it's datasheet mode!!
            if (rstore.letrAndTagStore.activeview === 'datasheet') {
                rstore.mainSchemaStore.addLink(lnote);
            }
            else {
                if (ismaindraft) {
                    rstore.draftDetailStore.setLink(lnote);
                }
                else {
                    rstore.miniviewStore.setLink(lnote);
                }
            }
        }
        rstore.floatingStore.setShow(false);
        rstore.floatingStore.reset();
        if (rstore.letrAndTagStore.canViewDocument()) {
            rstore.objectChooserStore.setActiveView("project");
        }
        else if (rstore.letrAndTagStore.canViewDatasheet()) {
            rstore.objectChooserStore.setActiveView("datasheet");
        }
        rstore.objectChooserStore.setShow(false);
        rstore.objectChooserStore.reset();
    }
    render() {
        const rstore = this.context;
        if (!rstore.floatingStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-viewer": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.floatingStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-viewer")) {
                    rstore.floatingStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.floatingStore.left + "px", top: rstore.floatingStore.top + "px", width: rstore.floatingStore.width + "px", height: testIsMobile() ? (window.innerHeight - 150) + "px" : (window.innerHeight - 100) + "px" },
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-viewer": 'colorbox', height: "50px", width: '100%' },
                React.createElement(Text, { overflow: 'hidden', textOverflow: 'ellipsis', title: rstore.floatingStore.title, width: '60%', "object-viewer": 'colorbox', fontWeight: 'bold', fontSize: '12px', fontFamily: 'heading', color: AppColor.InputLabelColor }, rstore.floatingStore.title),
                rstore.floatingStore.selectionmode && React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                    React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Add Selection', onClick: () => this.addLink() },
                        React.createElement(Icon, { w: '20px', h: '20px', color: AppColor.ActionMenuIcon, className: 'message-option-button', as: MdLink, ml: '1px' }),
                        React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Add Selection'))),
                rstore.floatingStore.linkingmode && React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                    React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Add Link', onClick: () => this.addLink() },
                        React.createElement(Icon, { w: '20px', h: '20px', color: AppColor.ActionMenuIcon, className: 'message-option-button', as: MdLink, ml: '1px' }),
                        React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Add Link'))),
                !rstore.floatingDraftViewStore.shownotespanel &&
                    React.createElement(Icon, { ml: '15px', _hover: { cursor: 'pointer' }, title: 'Show notes panel', onClick: () => rstore.floatingDraftViewStore.setShowNotesPanel(true), as: FiList }),
                React.createElement(Icon, { pos: 'absolute', right: '5px', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                        rstore.floatingStore.setShow(false);
                        rstore.floatingStore.reset();
                    }, className: 'message-option-button' })),
            rstore.floatingDraftViewStore.showdraftingview && rstore.floatingDraftViewStore.updating &&
                rstore.floatingDraftViewStore.drafttype === DraftType.XLSX
                && React.createElement(Flex, { "border-bottom": '1px solid lightgray', padding: '10px', "object-viewer": 'colorbox', height: "35px", width: '100%' },
                    React.createElement(Text, { width: '90%', "object-viewer": 'colorbox', fontWeight: 'bold', fontSize: '15px', fontFamily: 'heading' }, 'Rendering...')),
            rstore.floatingStore.loading && React.createElement(Flex, { h: '100%', w: '100%', mt: '10px', justify: 'center', align: 'center' },
                React.createElement(ScaleLoader, { color: 'green' })),
            !rstore.floatingStore.loading && React.createElement(Box, { h: '100%', w: '100%', mt: '10px' },
                React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                        React.createElement(ScaleLoader, { color: 'green' }),
                        React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising Editor...")) },
                    React.createElement(FloatingEditor, null))),
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', justify: 'flex-end', "object-viewer": 'colorbox', height: "30px", width: '100%' },
                React.createElement(Button, { w: '50px', variant: 'unstyled', onClick: () => {
                        rstore.floatingStore.setShow(false);
                        rstore.floatingStore.reset();
                    } }, "Close")));
    }
};
FloatingObjectViewer.contextType = StoreContext;
FloatingObjectViewer = __decorate([
    observer
], FloatingObjectViewer);
export { FloatingObjectViewer };
